import { useCallback, useState } from 'react';
import { IBookingAdvancedSearch, VehicleStatus } from '@/logic/api';

const defaultFilters: IBookingAdvancedSearch = {
    searchBy: {
        uuid: false,
        ref: true,
        vehicleRegistration: true,
        lastName: true,
        trackingId: false,
        altRef: false
    },
    filterBy: {
        vehicleStatus: [VehicleStatus.NotCheckedIn, VehicleStatus.CheckedIn],
        bookingStatus: []
    },
    allCarParks: false,
    exactMatch: true
};

let persistedFilters: IBookingAdvancedSearch = { ...defaultFilters };

export const useAdvancedSearchParams = () => {
    const [filters, setFilters] = useState<IBookingAdvancedSearch>(persistedFilters);

    const updateFilters = useCallback((newFilters: IBookingAdvancedSearch) => {
        persistedFilters = { ...newFilters };
        setFilters({ ...newFilters });
    }, []);

    const resetFilters = useCallback(() => {
        persistedFilters = { ...defaultFilters };
        setFilters({ ...defaultFilters });
    }, []);

    return {
        filters,
        updateFilters,
        resetFilters
    };
};